import pic from "../../assets/images/logo.png";
export default function LogoComponent() {
 return <img src={pic} />
}
